"use client";

import { useLCPDetection } from "@/hooks/use-lcp-detection";
import { safeJSON } from "@/utils/security";

// NOTE: Replace this with dynamic injection if needed. Meteor is not available in this environment.
const datasets = [
	{ datasetId: "957391556312769" },
	{ datasetId: "2812292702324975" },
	{ datasetId: "671447422188264" },
];

export function AnalyticsScripts() {
	const lcpCompleted = useLCPDetection();
	if (!lcpCompleted) {
		return null;
	}

	const scriptType = "text/javascript";

	return (
		<>
			{/* Facebook Pixel - Optimized for critical request chain */}
			<script
				type={scriptType}
				async
				defer
				dangerouslySetInnerHTML={{
					__html: `
						!function(f,b,e,v,n,t,s)
						{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
						n.callMethod.apply(n,arguments):n.queue.push(arguments)};
						if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
						n.queue=[];t=b.createElement(e);t.async=!0;t.defer=!0;
						t.src=v;s=b.getElementsByTagName(e)[0];
						s.parentNode.insertBefore(t,s)}(window, document,'script',
						'https://connect.facebook.net/en_US/fbevents.js');
						${datasets.map(d => `window.fbq('init', '${d.datasetId}');`).join("\n")}
						window.fbq('track', 'PageView');
					`,
				}}
			/>
			{/* Matomo - Optimized for critical request chain */}
			<script
				type={scriptType}
				async
				defer
				dangerouslySetInnerHTML={{
					__html: `
						window._paq = window._paq || [];
						window._paq.push(['trackPageView']);
						window._paq.push(['enableLinkTracking']);
						(function() {
							var u="//matomo.settlin.in/";
							window._paq.push(['setTrackerUrl', u+'matomo.php']);
							window._paq.push(['setSiteId', '1']);
							var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
							g.type='text/javascript'; g.async=true; g.defer=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
						})();
					`,
				}}
			/>
			{/* Mixpanel - Optimized for critical request chain */}
			<script
				type={scriptType}
				async
				defer
				dangerouslySetInnerHTML={{
					__html: `
						(function(c,a){if(!a.__SV){var b=window;try{var d,m,j,k=b.location,f=k.hash;d=function(a,b){return(m=a.match(RegExp(b+"=([^&]*)")))?m[1]:null};f&&d(f,"state")&&(j=JSON.parse(decodeURIComponent(d(f,"state"))),"mpeditor"===j.action&&(b.sessionStorage.setItem("_mpcehash",f),history.replaceState(j.desiredHash||"",c.title,k.pathname+k.search)))}catch(n){}var l,h;window.mixpanel=a;a._i=[];a.init=function(b,d,g){function c(b,i){var a=i.split(".");2==a.length&&(b=b[a[0]],i=a[1]);b[i]=function(){b.push([i].concat(Array.prototype.slice.call(arguments,0)))}}var e=a;"undefined"!==typeof g?e=a[g]=[]:g="mixpanel";e.people=e.people||[];e.toString=function(b){var a="mixpanel";"mixpanel"!==g&&(a+="."+g);b||(a+=" (stub)");return a};e.people.toString=function(){return e.toString(1)+".people (stub)"};l="disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(" ");for(h=0;h<l.length;h++)c(e,l[h]);var f="set_config"==l[h]?"config":l[h];a._i.push([b,d,g])};a.__SV=1.2;b=c.createElement("script");b.type="text/javascript";b.async=!0;b.defer=!0;b.src="undefined"!==typeof MIXPANEL_CUSTOM_LIB_URL?MIXPANEL_CUSTOM_LIB_URL:"file:"===c.location.protocol&&"//cdn4.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\\/\\//)?"https://cdn4.mxpnl.com/libs/mixpanel-2-latest.min.js":"//cdn4.mxpnl.com/libs/mixpanel-2-latest.min.js";d=c.getElementsByTagName("script")[0];d.parentNode.insertBefore(b,d)}})(document,window.mixpanel||[]);
						
						// Initialize Mixpanel with token only if available
						const token = ${safeJSON(process.env.NEXT_PUBLIC_MIXPANEL_TOKEN || "")};
						if (token && token.trim() !== "" && window.mixpanel && typeof window.mixpanel.init === 'function') {
							window.mixpanel.init(token, {
								debug: false
							});
						}
					`,
				}}
			/>
		</>
	);
}
